import type { FaireProductEntity } from "../../entity_types/product";

export const p_e74yh457dy: FaireProductEntity = {
  token: "p_e74yh457dy",
  type: "product",
  name: 'Small  Pipe Taper Holder-Taupe-2"H',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/aef4a5e29d13347a0352c91194def1a024ff5a6efd56c90ce9586df7e77d8c3c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/111f94fff4606e34d1e714180b7d975427e8966f24321fb67bd5859daf6da347.jpeg",
    "https://cdn.faire.com/fastly/59be589127acc25ce68366628ba2522774ca846549708572c961296b936abcaa.jpeg",
  ],
  priceDollars: 6.5,
  description:
    "Introducing our Small Pipe Taper Holder crafted from taupe glass. This holder features a sleek and minimalist design, with a cylindrical shape. Perfect for adding a modern and refined accent to any table setting or decor arrangement, this glass pipe taper holder combines functionality with understated beauty. Available in additional colours.",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:13.256Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
